import s from './NameCellRenderer.scss'
import { Link } from 'react-router-dom'

const NameCellRenderer = ({ data, path, property }) => {
  if (!data) return null
  let { id, firstName, lastName } = data
  if (property) {
    if (!data[property]) {
      return null
    }

    ;({ id, firstName, lastName } = data[property])
  }
  return (
    <Link className={s.link} to={`/${path}/${id}`}>
      {firstName} {lastName}
    </Link>
  )
}

export default NameCellRenderer
